import { useEffect, useState } from "react";

export interface DebounceResult {
    debouncing: boolean,
    startDebounce: (callback: () => void) => void,
    cancelDebounce: () => void,
}

type Timeout = ReturnType<typeof setTimeout>;

export default (durationMS: number): DebounceResult => {
    const [debounce, setDebounce] = useState<Timeout | null>(null);
    const [debouncing, setDebouncing] = useState<boolean>(false);

    const cancelDebounce = (): void => {
        if(debounce !== null) {
            clearTimeout(debounce);
            setDebouncing(false);
        }
    };
    const startDebounce = (callback: () => void) => setDebounce(oldTimeout => {
        if (oldTimeout !== null) {
            clearTimeout(oldTimeout);
        }
        setDebouncing(true);
        return setTimeout(() => {
            callback();
            setDebouncing(false);
        }, durationMS);
    });

    useEffect(() => cancelDebounce, []);

    return {
        debouncing,
        startDebounce,
        cancelDebounce,
    };
}
